import React from 'react';
import { Link, useLocation } from 'react-router-dom'; 
import './SideBar.css';

const Sidebar = ({ userType = 'admin' }) => {
    const location = useLocation();
    
    // Determine dashboard route based on user type
    const dashboardRoute = userType === 'employee' ? '/employee-dashboard' : '/admin-dashboard';
    const isDashboardActive = location.pathname === '/employee-dashboard' || location.pathname === '/admin-dashboard';
    
    return (
        <div className="sidebar">
            <ul>
                {/* Dashboard - Show for both admin and employee */}
                <li className={isDashboardActive ? "sidebar-active" : ""}>
                    <Link to={dashboardRoute}>Dashboard</Link>  
                </li>
                
                {/* Full Access - Orders */}
                <li className={location.pathname === "/orderHistory" ? "sidebar-active" : ""}>
                    <Link to="/orderHistory">Orders</Link>  
                </li>
                
                {/* Full Access - Dimension Requests */}
                <li className={location.pathname === "/dimension-requests" ? "sidebar-active" : ""}>
                    <Link to="/dimension-requests">Dimension Requests</Link>  
                </li>
                
                {/* Full Access - Metrics */}
                <li className={location.pathname === "/metrics" ? "sidebar-active" : ""}>
                    <Link to="/metrics">Metrics</Link>
                </li>
                
                {/* Read-Only for Employees - Users */}
                <li className={location.pathname === "/users" ? "sidebar-active" : ""}>
                    <Link to="/users">Users</Link>
                </li>
                
                {/* Read-Only for Employees - Products */}
                <li className={location.pathname === "/productPage" ? "sidebar-active" : ""}>
                    <Link to="/productPage">Products</Link>
                </li>
                
                {/* Read-Only for Employees - Artists & Artwork */}
                <li className={location.pathname === "/artistPage" ? "sidebar-active" : ""}>
                    <Link to="/artistPage">Artists & Artwork</Link>
                </li>
            </ul>
        </div>
    );
};

export default Sidebar;
